export default {
  nav: {
    categories: 'Categorias',
    topSites: 'Melhores sites',
    compare: 'Comparar',
    submitSite: 'Enviar site',
    about: 'Sobre',
    logIn: 'Entrar',
  },
  common: {
    back: 'Voltar',
    search: 'Pesquisar',
    loading: 'A carregar…',
    viewSimilarSites: 'Ver sites semelhantes',
  },
  hero: {
    badge: 'Motor de descoberta de sites',
    titleA: 'Encontre sites semelhantes aos',
    titleB: 'seus favoritos.',
    titlePrefix: 'Encontre sites semelhantes aos',
    titleAccent: 'seus favoritos.',
    subtitle: 'Descubra concorrentes, alternativas e pérolas escondidas na web com pontuações de similaridade precisas.',
    placeholder: 'Introduza um domínio (ex.: stripe.com)',
    inputPlaceholder: 'Introduza um domínio (ex.: stripe.com)',
    step1Label: 'Introduza um domínio',
    step1Desc: 'Escreva qualquer URL para começar',
    step2Label: 'Obter resultados',
    step2Desc: 'O nosso motor encontra sites semelhantes instantaneamente',
    step3Label: 'Comparar e decidir',
    step3Desc: 'Analise e compare alternativas',
    steps: {
      step1Label: 'Introduza um domínio',
      step1Desc: 'Escreva qualquer URL para começar',
      step2Label: 'Obter resultados',
      step2Desc: 'O nosso motor encontra sites semelhantes instantaneamente',
      step3Label: 'Comparar e decidir',
      step3Desc: 'Analise e compare alternativas',
    },
  },
  footer: {
    newsletterTitle: 'Fique atualizado',
    newsletterDesc: 'Receba relatórios semanais sobre sites em tendência e novas alternativas.',
    emailPlaceholder: 'o_seu@email.com',
    subscribe: 'Subscrever',
    brandDesc: 'Descubra ligações escondidas na web. Encontre sites semelhantes aos seus favoritos com pontuação precisa.',
    explore: 'Explorar',
    popular: 'Popular',
    company: 'Empresa',
    compareSites: 'Comparar sites',
    sitesLike: 'Sites como',
    contact: 'Contacto',
    faq: 'FAQ',
    removeYourSite: 'Remover o seu site',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de serviço',
    rights: 'Todos os direitos reservados.',
  },
  notFound: {
    title: 'Ops! Página não encontrada',
    returnHome: 'Voltar ao início',
  },
  submitPage: {
    ctaTitle: 'Conhece um site excelente?',
    ctaDesc: 'Ajude-nos a crescer enviando sites de que gosta. Leva apenas alguns segundos.',
    ctaButton: 'Enviar site',
    pageTitle: 'Enviar um site',
    pageSubtitle: 'Ajude-nos enviando um site para indexação.',
    successTitle: 'Site enviado!',
    successReviewPrefix: 'Vamos analisar',
    successReviewSuffix: 'e adicioná-lo ao nosso índice em breve.',
    backHome: 'Voltar ao início',
    domainLabel: 'Domínio *',
    domainPlaceholder: 'ex.: example.com',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Breve descrição do site',
    categoryLabel: 'Categoria',
    categorySelect: 'Selecione uma categoria',
    alternativeTo: 'Alternativa a (opcional)',
    alternativeNone: 'Nenhuma — não é alternativa',
    emailLabel: 'O seu email',
    emailPlaceholder: 'voce@exemplo.com',
    submitButton: 'Enviar site',
    submitFailed: 'Falha ao enviar',
    seoTitle: 'Enviar site | CiteMatch',
    seoDesc: 'Envie um site para indexação no CiteMatch.',
  },
};

